module.exports = __webpack_public_path__ + "img/2.0308dd86.png";